import {groupCompanyProtocolApi} from 'pages/ais/organization-structure-v5/api/group-company-protocol.api';
import {IGetDataArgs} from 'pages/ais/organization-structure-v5/model/types';

export const GroupCompanyProtocolTabService = {
    get: async (args?: IGetDataArgs) => {
        try {
            return await groupCompanyProtocolApi.getData(args);
        } catch (error) {
            throw new Error(error);
        }
    },

    getById: async (id: number) => {
        try {
            return await groupCompanyProtocolApi.getDataById(id);
        } catch (error) {
            throw new Error(error);
        }
    },
};